import React from 'react';
import { FlagIcon } from 'react-flag-kit';
import { useTranslation } from 'react-i18next';
import StyledCard from '../../../../shared/layout/cards/StyledCard';
import CardHeader from '../../../../shared/layout/cards/CardHeader';
import CardTitle from '../../../../shared/layout/cards/CardTitle';
import CardBody from '../../../../shared/layout/cards/CardBody';
import ListGroup from '../../../../shared/layout/containers/ListGroup';
import ListItem from '../../../../shared/layout/containers/ListItem';
import FlagContainer from '../../../../shared/layout/containers/FlagContainer';
import CountryDetails from '../../../../shared/layout/containers/CountryDetails';
import CountrySales from '../../../../shared/layout/typography/CountrySales';
import CountryUsers from '../../../../shared/layout/typography/CountryUsers';
import Badge from '../../../../shared/layout/typography/Badge';

const SalesByCountries = ({ data }) => {
    const { t } = useTranslation();

    return (
        <StyledCard>
            <CardHeader>
                <CardTitle>{t('Users.UserStatistics.salesByCountry.title')}</CardTitle>
            </CardHeader>
            <CardBody textSize="extraSmall">
                <ListGroup>
                    {data && data.map((countryData, index) => (
                        <ListItem key={index}>
                            <FlagContainer>
                                {countryData.country?.iso && (
                                    <FlagIcon code={countryData.country.iso} size={48} className="rounded" />
                                )}
                            </FlagContainer>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <CountryDetails>
                                    <CountrySales>{countryData.country?.name || t('common.unknown')}</CountrySales>
                                    <CountryUsers>
                                        {t('Users.UserStatistics.salesByCountry.userCount', { userCount: countryData.user_count })}
                                    </CountryUsers>
                                </CountryDetails>
                                <Badge variant="sales">${parseFloat(countryData.total_sales || 0).toLocaleString()}</Badge>
                            </div>
                        </ListItem>
                    ))}
                    {(!data || data.length === 0) && (
                        <ListItem>
                            <p style={{ padding: '0.625rem', color: '#6b7280' }}>
                                {t('Users.UserStatistics.noData')}
                            </p>
                        </ListItem>
                    )}
                </ListGroup>
            </CardBody>
        </StyledCard>
    );
};

export default SalesByCountries;
